//import { colors } from '@mui/material';
import {createTheme} from '@mui/material/styles'; 
import { lighten} from "polished";

export const Colors = {
    primary: "#5f2c3e",
    secondary: "#d1adcc",
    success: "#4CAF50",
    info: "#00a2ff",
    danger: "#FF5722",
    warning: "#FFC107",
    dark: "#0e1b20",
    light: "#aaa",
    muted: "#abafb3",
    border: "#DDDFE1",
    inverse: "#2F3D4A",
    shaft: "#333",
    black_light : "#303633",
    scarlet : "#EF2B31",
    blue_sky : "#0055F3",
    ///////////////
    // Grays
    ///////////////
    dim_grey: "#696969",
    dove_gray: "#d5d5d5",
    body_bg: "#f3f6f9",
    light_gray: "rgb(230,230,230)",
    ///////////////
    // Solid Color
    ///////////////
    white: "#fff",
    black: "#000",
};

const theme = createTheme({
    palette: {
        primary : {
            main : Colors.primary
        },

        secondary : {
            main : Colors.secondary
        } 
    },

    components : {
        MuiButton : {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
            },
        },


        //Custom Menu Mobile
        MuiDrawer : {
            styleOverrides: {
                paper: {
                    width: 250,
                    background: Colors.black_light,
                    color: Colors.white,
                    borderRadius: '0px 100px 0px 0px',
                    borderRight: `1px solid ${Colors.scarlet}`
                }
            }
        },

        MuiDivider : {
            styleOverrides : {
                root : {
                    borderColor: lighten(0.2, Colors.scarlet)
                }
            }
        },

        //custom mui pour le boutton
        
        MyShopButton : {
            styleOverrides : {
                root : {
                    color : Colors.white,
                },
                primary : {
                    background: Colors.black_light,
                    "&:hover": {
                        background:lighten(0.05, Colors.black_light),
                    },

                },
                secondary: {
                    background: Colors.secondary,
                    "&:hover": {
                        background:lighten(0.05, Colors.primary)
                    },
                },
            },
        }
    },

   

});

export default theme;
  